import React from 'react';
import GoogleMeetIcon from "../../../assets/icons/google-meet.svg";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import { GOOGLE_MEET_APP_ID } from '../../../data/integration-app';
import Linked from "./Linked";
import FeatureLock from "../../../components/FeatureLock/FeatureLock";
import { FEATURE_IDS } from "../../../constants/featureAccess";


const GoogleMeet = ({connectedVenues}) => {
    
    return (
        <Col md="6" xxl="3" xl="4">
            <FeatureLock featureId={FEATURE_IDS.GOOGLE_MEET}>
                <Link
                to="/integrations/meet"
                className="int-col"
                >
                {connectedVenues.some(data => parseInt(data.app_id) === GOOGLE_MEET_APP_ID) && <Linked />}    
                <div className="img">
                    <img src={GoogleMeetIcon} alt="Google Meet" />
                </div>
                <div className="text">
                    <h3>Google Meet</h3>
                    <p>
                    Connect and collaborate with Google Meet — secure video meetings made easy.
                    </p>
                </div>
                </Link>
            </FeatureLock>
        </Col>
    );
}

export default GoogleMeet;
